import React, { useState } from "react";
import { SiTrello } from "react-icons/si";

import { BsSuitHeart } from "react-icons/bs";
import { AiOutlineUsergroupAdd, AiOutlineSetting } from "react-icons/ai";

import { Button, Offcanvas } from "react-bootstrap";

const Offcanva = ({ show, close }) => {
  return (
    <>
      <Offcanvas
        show={show}
        onHide={close}
        style={{ backgroundColor: "#0066a0", color: "white", width: "300px" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {" "}
            <div
              style={{
                gap: "8px",
                marginTop: "25px",
                width: "250px",
                padding: "2px",
                fontWeight: "800",
              }}
            >
              <span
                style={{
                  backgroundColor: "#4CA1A3",
                  color: "white",
                  padding: "3px",
                  fontSize: "20px",
                  marginRight: "4px",
                  borderRadius: "2px",
                  paddingTop: "8px",
                }}
              >
                N{" "}
              </span>{" "}
              New Workspace
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <hr />
        <Offcanvas.Body>
          <div className="list-item-wrapper">
            <ul style={{ gap: "55px", fontSize: "14px" }}>
              <li
                style={{
                  display: "flex",
                  gap: "15px",
                  marginBottom: "18px",
                  // color: "#DFDFDE",
                }}
              >
                <SiTrello />
                Boards
              </li>
              <li
                style={{ display: "flex", gap: "15px", marginBottom: "18px" }}
              >
                <BsSuitHeart />
                Highlights
              </li>
              <li
                style={{ display: "flex", gap: "15px", marginBottom: "18px" }}
              >
                <AiOutlineUsergroupAdd />
                Members
              </li>
              <li
                style={{ display: "flex", gap: "15px", marginBottom: "18px" }}
              >
                <AiOutlineSetting />
                Settings
              </li>
            </ul>
          </div>

          <div>
            <span>Workspace Views</span>

            <div className="list-item-wrapper">
              <ul style={{ gap: "55px", fontSize: "14px" }}>
                <li
                  style={{
                    display: "flex",
                    gap: "15px",
                    marginBottom: "18px",
                    // color: "#DFDFDE",
                  }}
                >
                  <SiTrello />
                  Table
                </li>
                <li
                  style={{ display: "flex", gap: "15px", marginBottom: "18px" }}
                >
                  <BsSuitHeart />
                  Calender
                </li>
              </ul>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Offcanva;
